import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", null, "Voordelig en snel een energiecontact aanvragen is het makkelijkst met de energievergelijker. Vul de vergelijker in en sluit direct uw energiecontract af. ", -1)

import { useRouter } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'EnergyComparisonWidget',
  setup(__props) {

const router = useRouter()

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, { title: "Energievergelijker" }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createVNode(_component_a_button, {
        type: "primary",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ name: 'EnergyComparison', query: { gas_available: 0 } })))
      }, {
        default: _withCtx(() => [
          _createTextVNode("Ga naar de vergelijker")
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})